import { createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';

export const getSsoMetadata = createApiAction(
  types.GET_SSO_METADATA,
  (payload) => api.getSaml(payload),
  { meta: { skipErrorPage: true } },
);

export const updateSsoMetadata = createApiAction(
  types.UPDATE_SSO_METADATA,
  (payload) => api.updateSaml(payload),
);

export const deleteSsoMetadata = createApiAction(
  types.DELETE_SSO_METADATA,
  (payload) => api.deleteSaml(payload),
);

// All actions below belong to Global SSO managed via sso-service.
export const getConfig = createApiAction(
  types.GET_SSO_CONFIG,
  (payload) => api.getConfig(payload),
  { meta: { skipErrorPage: true } },
);

export const updateConfig = createApiAction(
  types.UPDATE_SSO_CONFIG,
  (payload) => api.updateConfig(payload),
);

export const deleteConfig = createApiAction(
  types.DELETE_SSO_CONFIG,
  (payload) => api.deleteConfig(payload),
);

export const checkAvailable = createApiAction(
  types.CHECK_SSO_CONFIG_AVAILABLE,
  (payload) => api.checkAvailable(payload),
  { meta: { skipErrorPage: true } },
);
